/**
 * Firebase web SDK initialization.
 *
 * Mirrors flock-expo/src/services/firebase.ts for web: Auth with local
 * persistence, Firestore with persistent multi-tab cache (offline support +
 * shared cache across tabs), and Storage for chat image uploads.
 */
import { initializeApp } from 'firebase/app';
import { browserLocalPersistence, getAuth, setPersistence } from 'firebase/auth';
import {
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

export const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Fire-and-forget: browserLocalPersistence is already the default on web,
// set explicitly to make the contract obvious.
setPersistence(auth, browserLocalPersistence).catch((e) => {
  console.warn('[Firebase] Failed to set auth persistence:', e);
});

export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
});

export const storage = getStorage(app);

if (import.meta.env.DEV) {
  console.log(`[Firebase] Initialized for project: ${firebaseConfig.projectId}`);
}
